export default __webpack_public_path__ + "static/preview-2d1c5c94bed876081e174e319d806664.png";